export default "__VITE_PUBLIC_ASSET__e95ba727__"